import { ApolloError } from '@apollo/client';
import { ReactNode } from 'react';

interface ErrorFields {
  [fieldName: string]: string[];
}

type ApolloOriginalError = {
  fields?: ErrorFields[];
  message?: string;
};

export const getApolloErrorsForToast = (e: ApolloError): ReactNode => {
  return (
    <div>
      {e?.graphQLErrors?.map(({ extensions, path, message }, errorIndex) => {
        const original = extensions?.originalError as ApolloOriginalError | undefined;
        const fields: ErrorFields[] = original?.fields || [];
        const fallbackMessage = original?.message || message || 'Unknown error';

        if (!fields.length) {
          return (
            <div key={errorIndex}>
              <p>{fallbackMessage}</p>
            </div>
          );
        }

        return fields.map((field) => {
          const [fieldName, errors] = Object.entries(field)[0] || ['', []];

          return (
            <div key={`${errorIndex}-${fieldName}`}>
              <p className="font-medium">
                {`${path ? path[0] : ''} ${fieldName}`}:
              </p>
              <div className="ml-2 text-sm">
                {errors?.map((err, errIndex) => (
                  <p key={`${errorIndex}-${fieldName}-${errIndex}`}>{err}</p>
                ))}
              </div>
            </div>
          );
        });
      })}
    </div>
  );
};
